export class FetchOptions {
  key: string;
  displayName: string;
  grossCharge: number;
  stbOptionsList: StbOption[];
  subscribed: boolean;
  toDelete: boolean;

}

export class StbOption{
  key: string;
  displayName: string;
  grossCharge: number;
}
